import type { TScrollState } from '../interfaces/hoc/withScroll.types';
import type { TNavLink } from '../interfaces/shared';
import { SECTIONS } from './sections';

export const SITE_NAME = 'Bunker Suite' as const;

export const initialScrollState: TScrollState = {
  isVisible: true,
  hasScrolled: false,
  scrollDirection: null,
} as const;

export const SYSTEM_ROUTES = {
  HOME: '/',
  ROLES: 'roles',
  FEATURES: 'features',
  PLATFORM: 'platform',
  COMPANY: 'company',
  CONTACT: 'contact',
} as const;

const NAV_LINKS_BASE: TNavLink[] = [
  {
    id: 'roles',
    label: 'Roles',
    href: `${SYSTEM_ROUTES.HOME}#${SYSTEM_ROUTES.ROLES}`,
  },
  {
    id: 'features',
    label: 'Features',
    href: `${SYSTEM_ROUTES.HOME}#${SYSTEM_ROUTES.FEATURES}`,
  },
  {
    id: 'platform',
    label: 'Platform',
    href: `${SYSTEM_ROUTES.HOME}#${SYSTEM_ROUTES.PLATFORM}`,
  },
  {
    id: 'company',
    label: 'Company',
    href: `${SYSTEM_ROUTES.HOME}#${SYSTEM_ROUTES.COMPANY}`,
  },
  {
    id: 'press',
    label: 'Press',
    href: '/press',
  },
  {
    id: 'contact',
    label: 'Contact',
    href: `${SYSTEM_ROUTES.HOME}#${SYSTEM_ROUTES.CONTACT}`,
  },
] as const;

export const NAV_LINKS: TNavLink[] = NAV_LINKS_BASE.filter((item) => {
  if (item.id === 'hero') return SECTIONS.hero;
  if (item.id === 'roles') return SECTIONS.roles;
  if (item.id === 'features') return SECTIONS.features;
  if (item.id === 'platform') return SECTIONS.platform;
  if (item.id === 'company') return SECTIONS.company;
  if (item.id === 'contact') return SECTIONS.contact;
  return true;
});

export const SUCCESS_CONTACT_MESSAGE = {
  toastKey: 'success',
  message: 'Your message has been sent successfully',
} as const;

export const ERROR_CONTACT_MESSAGE = {
  toastKey: 'error',
  message: 'Failed to send message',
} as const;

export const REQUIRED_MESSAGE = '*Required';

export const FORM_SPREE_URL = 'https://formspree.io/f/xdkdlrjk';
export const FORM_SPREE_FEATURES_URL = FORM_SPREE_URL;
